import script from "./ScrollToTop.vue?vue&type=script&setup=true&lang=js"
export * from "./ScrollToTop.vue?vue&type=script&setup=true&lang=js"

import "./ScrollToTop.vue?vue&type=style&index=0&id=6d4fc582&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d4fc582"]])

export default __exports__